module.exports = __webpack_public_path__ + "img/hopways-03.c4e85941.webp";